import { TopicSelector } from './topic_selector';
import { WorkbenchManager } from './workbench_manager';

class Workbench {
   constructor(options) {
      this.lastMounted = null;
   }

   // Add event listeners for each of the items within Workbench. This allows
   // users to add, select, and remove items.
   addEventListeners(workbenchContainer) {
      if (workbenchContainer === this.lastMounted) {
         return;
      }

      // Preserve the scope of the outer Workbench class.
      var self = this;

      workbenchContainer.addEvent('click:relay(.js-add-topic-button)', function() {
         // Close Workbench immediately when Device Picker opens.
         document.getElementById('workbenchDropdownToggle').parentNode.click();

         self.selectDevice();
      });

      workbenchContainer.addEvent('click:relay(.js-workbench-topic)', function(e) {
         var topicEl = this;
         var wikiid = topicEl.get('data-wikiid');
         var topicVariantid = topicEl.get('data-topic-variantid');
         var workbenchScroll = new Fx.Scroll('workbench-topic-container');

         if (
            e.target.hasClass('js-delete-topic-button') ||
            e.target.getParent('.js-delete-topic-button')
         ) {
            self.removeDevice(topicVariantid, wikiid);
         } else {
            $$('.js-topic-animation-container').dissolve({
               duration: 150,
            });
            $$('.js-workbench-topic').removeClass('selected-topic');

            this.getChildren('.js-topic-animation-container').reveal({
               heightOverride: 60,
               duration: 150,
               onShow: function() {
                  setTimeout(function() {
                     workbenchScroll.toElement(topicEl);
                  }, 150);
               },
            });

            this.addClass('selected-topic');
         }
      });

      this.lastMounted = workbenchContainer;
   }

   removeDevice(topicVariantid, wikiid) {
      WorkbenchManager.removeItem(topicVariantid, wikiid, /* useIndicator */ false);

      topicVariantid = topicVariantid || 'generic';

      when($('topic-' + topicVariantid), function(topicCheckmark) {
         topicCheckmark.set('checked', false);
      });

      TopicSelector.updateVariantDropdownState();
   }

   async selectDevice() {
      const { default: DevicePickerService } = await import(
         /* webpackPreload: true */ './device_picker_service'
      );
      const selectedDevice = await DevicePickerService.selectDevice({
         allowOrphan: false,
         initialView: 'COLUMN',
      });

      // Open Workbench after selecting a device.
      document.getElementById('workbenchDropdownToggle').parentNode.click();

      WorkbenchManager.addItem(
         /* variantid */ null,
         /* wikkiid */ null,
         /* showIndicator */ true,
         selectedDevice
      );
   }
}

export default Workbench;
